var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 2023-10-05
 * @brief SEI  로그인 -  컴포넌트
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
// design
import $ from "jquery";
import "/static/css/style.css";
// recoil
import { getApiLangState, langId, langState } from "../../recoil/langState";
import { contactusState, urlState } from "../../recoil/menuState";
import { authId, authState, userInfoState } from "../../recoil/userState";
// utils
import * as HttpUtil from "../../utils/api/HttpUtil";
import * as CUTIL from "../../utils/commUtils";
import * as CONST from "../../utils/Const";
import * as i18n from "../../utils/langs/i18nUtils";
import { useTrans } from "../../utils/langs/useTrans";
import * as USERUTILS from "../../utils/user/userUtils";
//
import Captcha from "@components/common/Captcha";
import CommonPopup, { usePopup } from "@components/common/popup/CommonPopup";
import AgreementPersonalDataPop from "@components/common/popup/terms/AgreementPersonalDataPop";
import PrivacyPolicyPop from "@components/common/popup/terms/PrivacyPolicyPop";
import TremmPop from "@components/common/popup/terms/TermsPop";
import { alertState, noneUrl } from "../../recoil/assessmentState";
import AlertPop from "../common/popup/AlertPop";
import FindIdPop from "../common/popup/seijoin/FindPIdPop";
import FindPwdPop from "../common/popup/seijoin/FindPwdPop";
import JoinCompanyPop from "../common/popup/seijoin/JoinCompanyPop";
import JoinDonePop from "../common/popup/seijoin/JoinDonePop";
import JoinNewCompanyPop from "../common/popup/seijoin/JoinNewCompanyPop";
import JoinPop from "../common/popup/seijoin/JoinPop";
function Login() {
    // trans, navigate, ref
    const navigate = useNavigate();
    const t = useTrans();
    // use recoil
    const isAuth = useRecoilValue(authState);
    const apiLang = useRecoilValue(getApiLangState);
    const [langs, setRecoilLangs] = useRecoilState(langState); // recoil langState
    const [userInfo, setRecoilUserInfo] = useRecoilState(userInfoState); // recoil userState
    const [recilUrl, setRecoilUrl] = useRecoilState(urlState);
    const setRecoliUserId = useSetRecoilState(authId);
    const [reContactusState, setReContactusState] = useRecoilState(contactusState);
    const setRecoilNoneUrlInfo = useSetRecoilState(noneUrl);
    const [langIds, setRecoilLangIds] = useRecoilState(langId);
    const [userId, setUserId] = useState(""); //test@test.com
    const [userPw, setUserPw] = useState(""); //1234qwer!@
    const [alert, setAlert] = useRecoilState(alertState);
    // 이상징후 판별(CAPTCHA) - 비밀번호 연속 불일치 4회 이상부터 서버가 captchaRequired 를 내려준다.
    const [captchaRequired, setCaptchaRequired] = useState(false);
    const [captchaKey, setCaptchaKey] = useState("");
    const [captchaValue, setCaptchaValue] = useState("");
    const [captchaReload, setCaptchaReload] = useState(0); // 값이 바뀌면 CAPTCHA 재발급
    const [passwordOpen, setPasswordOpen] = useState(false); // 비밀번호 표시/숨김 토글
    // 초기 로그인 유지 여부를 "Y"로 셋팅
    localStorage.setItem(CONST.STR_KEEP_LOGIN_YN, "Y");
    const [keepLoginYn, setKeepLoginYn] = useState(localStorage.getItem(CONST.STR_KEEP_LOGIN_YN) == null ? "N" : localStorage.getItem(CONST.STR_KEEP_LOGIN_YN));
    // useAsync call axios
    const [errorList, setErrorList] = useState([]);
    const { data: data, error, isLoading, reload, run: runLogin, } = useAsync({
        deferFn: HttpUtil.Http,
        httpMethod: "POST",
        appPath: "/auth/login",
        appQuery: {
            userId: userId,
            password: userPw,
            language: apiLang,
            captchaKey: captchaRequired ? captchaKey : null,
            captchaValue: captchaRequired ? captchaValue : null,
        },
    });
    useEffect(() => {
        if (data) {
            // 이상징후 판별 - 서버가 CAPTCHA 노출 여부를 내려준다.
            // 발급키는 1회용이라 로그인이 실패할 때마다 새 CAPTCHA 를 받아와야 한다.
            if (data.data && data.data.captchaRequired === true) {
                setCaptchaRequired(true);
                setCaptchaReload((prev) => prev + 1);
            }
            else if ((data.data && data.data.captchaRequired === false) || data.codeNum == 200) {
                // 서버가 CAPTCHA 불필요를 명시(계정 잠김 등)하거나 로그인 성공 시 CAPTCHA 를 숨긴다.
                // (5회 도달로 계정이 잠기면 서버가 captchaRequired=false 를 내려주므로 이미지/입력란이 사라진다)
                setCaptchaRequired(false);
                setCaptchaKey("");
                setCaptchaValue("");
            }
            if (data.codeNum == 200) {
                // sessionStorage
                sessionStorage.setItem(CONST.STR_TOKEN, data.body.token);
                sessionStorage.setItem(CONST.STR_TOKEN_EXPIRETIME, data.body.tokenExpireTime);
                // localStorage
                localStorage.setItem(CONST.STR_USERID, userId);
                localStorage.setItem(CONST.STR_USERROLE, data.body.role);
                localStorage.setItem(CONST.STR_REFRESHTOKEN, data.body.refreshToken);
                localStorage.setItem(CONST.STR_REFRESHTOKEN_EXPIRETIME, data.body.refreshTokenExprieTime);
                localStorage.removeItem("demo");
                (() => __awaiter(this, void 0, void 0, function* () {
                    // IFFE(Immediately Invoked Function Expression)은 함수가 정의되자마자 실행되는 자바스크립트 기술입니다.
                    const detailUserInfo = yield USERUTILS.getDetailUserInfoR(data.body);
                    const lang = CUTIL.frontLangSet(detailUserInfo.language);
                    yield i18n.changeLang(lang);
                    //
                    setRecoilLangs(lang);
                    //
                    setRecoilUserInfo({
                        loginTime: detailUserInfo.loginTime,
                        userId: detailUserInfo.userId,
                        email: detailUserInfo.email,
                        userName: detailUserInfo.userName,
                        phoneNumber: detailUserInfo.phoneNumber,
                        companyName: detailUserInfo.companyName,
                        zoneName: detailUserInfo.zoneName,
                        department: detailUserInfo.department,
                        role: detailUserInfo.role,
                        language: detailUserInfo.language,
                        classificationCode: detailUserInfo.classificationCode,
                        classification: detailUserInfo.classification,
                        agreeMailReceipt: detailUserInfo.agreeMailReceipt,
                        agreeTos: detailUserInfo.agreeTos,
                        agreePersonalInfo: detailUserInfo.agreePersonalInfo,
                        agreeData: detailUserInfo.agreeData,
                        userIdPk: detailUserInfo.userIdPk,
                        isAutomatedNickName: detailUserInfo.isAutomatedNickName,
                        nickName: detailUserInfo.nickName,
                        userRank: detailUserInfo.userRank,
                        userImage: detailUserInfo.userImage,
                        loginInfo: data.body,
                    });
                    // TODO :: 추후에 url 받는 기준으로 진입하게 수정
                    // if (detailUserInfo.role == CONST.USERROLE_ENGINEER) {
                    //   setRecoilUrl(CONST.URL_TODAYINSPECTION);
                    //   navigate(CONST.URL_TODAYINSPECTION);
                    // } else
                    if (detailUserInfo.role === CONST.USERROLE_NONE) {
                        setRecoilUrl(CONST.URL_HELP);
                        navigate(CONST.URL_HELP);
                    }
                    else {
                        setRecoilUrl(CONST.URL_MONITORING);
                        navigate(CONST.URL_MONITORING);
                    }
                    window.location.reload();
                }))();
            }
            else if (data.codeNum == 113) {
                setAlert(Object.assign(Object.assign({}, alert), { header: langIds > 1 ? "Guide" : "안내", divTag: data.data.errorList[0].msg, callBack: () => {
                        setReContactusState(Object.assign(Object.assign({}, reContactusState), { code: "C01_07", codeName: "COMMUNITY", description: langIds > 1 ? "Community Usage Inquiry" : "커뮤니티 이용 문의", id: langIds > 1 ? 922 : 921 }));
                        setRecoilUrl(CONST.URL_CONTACTUS);
                        navigate(CONST.URL_CONTACTUS);
                        setRecoilNoneUrlInfo(true);
                    } }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            }
            else if (data.codeNum == 999) {
                setErrorList(data.data.errorList);
                setUserPw(""); // 로그인 실패 시 비밀번호 입력란 초기화
            }
            else {
                setErrorList(data.data.errorList);
                setUserPw(""); // 로그인 실패 시 비밀번호 입력란 초기화
                if (data.data.errorList.some((error) => error.msg.includes("인증") || data.errorList.some((error) => error.msg.includes("authenticated")))) {
                    setRecoliUserId(userId);
                    CUTIL.jsopen_AlertPopup("join-ok");
                    // if (!CUTIL.isnull(logCertification)) logCertification.click();
                }
            }
        }
    }, [data]);
    useEffect(() => {
        if (isAuth) {
            const userRole = localStorage.getItem(CONST.STR_USERROLE);
            /*   if ((userRole) && (userRole === CONST.USERROLE_NONE)) {
                setRecoilUrl(CONST.URL_LANDING);
              } else  */
            // TODO :: 추후에 url 받는 기준으로 진입하게 수정
            // if (userRole == CONST.USERROLE_ENGINEER) {
            //   setRecoilUrl(CONST.URL_TODAYINSPECTION);
            //   navigate(CONST.URL_TODAYINSPECTION);
            // } else
            if (userRole === CONST.USERROLE_NONE) {
                setRecoilUrl(CONST.URL_HELP);
                navigate(CONST.URL_HELP);
            }
            else {
                setRecoilUrl(CONST.URL_MONITORING);
                navigate(CONST.URL_MONITORING);
            }
        }
    }, []);
    function handleSetUserId(val) {
        if (errorList.filter((err) => err.field === "cntError").length) {
            setErrorList(errorList.filter((err) => err.field !== "cntError"));
            setUserId(val);
        }
        else {
            setErrorList(errorList.filter((err) => err.field !== "userId"));
            setUserId(val);
        }
    }
    function handleSetUserPw(val) {
        if (errorList.filter((err) => err.field === "cntError").length) {
            setErrorList(errorList.filter((err) => err.field !== "cntError"));
            setUserPw(val);
        }
        else {
            setErrorList(errorList.filter((err) => err.field !== "password"));
            setUserPw(val);
        }
    }
    function onClickLogin(e) {
        runLogin();
    }
    function handleonKeyDown(e, type) {
        if (e.key === "Enter") {
            // Enter 입력이 되면 클릭 이벤트 실행
            if (type === "INPUT_PASSWORD") {
                onClickLogin(e);
            }
        }
    }
    // 다국어 설정 변경 및 recoil 상태 변경
    function exchgLanguage(e, lang) {
        return __awaiter(this, void 0, void 0, function* () {
            // $(".navbar__menu li.active ul li").removeClass("active");
            $(".select-lang button.btn.btn-txt").removeClass("on");
            var tmpTag = e.target.tagName == "BUTTON" ? e.target : e.currentTarget;
            tmpTag.className = "btn btn-txt on";
            const langId = CUTIL.LangIdSet(lang);
            yield i18n.changeLang(lang);
            setRecoilLangIds(langId);
            setRecoilLangs(lang);
        });
    }
    const { openInnerPopup, closePopup } = usePopup();
    const onClickTermsPop = () => {
        openInnerPopup(_jsx(TremmPop, { closePopup: closePopup, type: "land" }));
    };
    const onClickPrivacyPolicyPop = () => {
        openInnerPopup(_jsx(PrivacyPolicyPop, { closePopup: closePopup, type: "land" }));
    };
    const onClickAgreementPop = () => {
        openInnerPopup(_jsx(AgreementPersonalDataPop, { closePopup: closePopup, type: "land" }));
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ id: "login", className: "login type2" }, { children: [_jsxs("div", Object.assign({ className: "login__left" }, { children: [_jsx("div", Object.assign({ className: "left__top" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "LS" })) })), _jsxs("div", Object.assign({ className: "left__center" }, { children: [_jsx("p", { children: "Welcome to LS ELECTRIC" }), _jsx("h1", { children: _jsx("img", { src: require("/static/img/logo_login_title_beyondx.svg"), alt: "BeyondXEnable" }) })] })), _jsx("p", Object.assign({ className: "left__bottom" }, { children: "LS ELECTRIC \u00A9" }))] })), _jsxs("div", Object.assign({ className: "login__right" }, { children: [_jsxs("h2", { children: [_jsxs("p", { children: [_jsx("span", { children: "Welcome to LS ELECTRIC" }), _jsx("span", { children: _jsx("img", { src: require("/static/img/logo_login_title_color_beyondx.svg"), alt: "BeyondXEnable" }) })] }), _jsx("p", { children: t("라벨.로그인해주십시오") })] }), _jsx("div", Object.assign({ className: "login__form" }, { children: _jsx("form", Object.assign({ action: "#", method: "", name: "loginform" }, { children: _jsxs("fieldset", { children: [_jsx("legend", { children: "\uB85C\uADF8\uC778 \uC815\uBCF4 \uC785\uB825" }), _jsxs("ul", Object.assign({ className: "form__input" }, { children: [_jsxs("li", { children: [_jsx("label", Object.assign({ htmlFor: "userId", className: "hide" }, { children: "\uC544\uC774\uB514 \uC785\uB825" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "userId", placeholder: t("라벨.아이디"), className: errorList.filter((err) => err.field === "cntError").length > 0 ||
                                                                        errorList.filter((err) => err.field === "userId").length > 0
                                                                        ? "input-error"
                                                                        : "", value: userId, onChange: (e) => handleSetUserId(e.target.value) }) }))] }), _jsxs("li", Object.assign({ style: { marginBottom: errorList.length > 0 ? "2.5rem" : undefined } }, { children: [_jsx("label", Object.assign({ htmlFor: "userPw", className: "hide" }, { children: "\uBE44\uBC00\uBC88\uD638 \uC785\uB825" })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: passwordOpen ? "text" : "password", id: "userPw", autoComplete: "on", placeholder: t("라벨.비밀번호"), className: errorList.filter((err) => err.field === "cntError").length > 0 ||
                                                                            errorList.filter((err) => err.field === "password").length > 0 ||
                                                                            errorList.filter((err) => err.field === "userId").length > 0
                                                                            ? "input-error"
                                                                            : "", value: userPw, onChange: (e) => handleSetUserPw(e.target.value), onKeyDown: (e) => handleonKeyDown(e, "INPUT_PASSWORD") }), errorList.length === 0 && (_jsx("button", Object.assign({ type: "button", style: {
                                                                            position: "absolute",
                                                                            right: "8px",
                                                                            top: "50%",
                                                                            transform: "translateY(-50%)",
                                                                            border: 0,
                                                                            background: "transparent",
                                                                            padding: 0,
                                                                            cursor: "pointer",
                                                                        }, onClick: () => setPasswordOpen(!passwordOpen) }, { children: _jsx("i", { className: passwordOpen ? "icon-eye" : "icon-eye-off" }) }))), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "password").map((err) => err.msg).length > 0
                                                                            ? errorList.filter((err) => err.field === "password").map((err) => err.msg)
                                                                            : errorList.filter((err) => err.field === "cntError").length > 0
                                                                                ? errorList.filter((err) => err.field === "cntError").map((err) => err.msg)
                                                                                : errorList.filter((err) => err.field === "userId").map((err) => err.msg) }))] }))] })), captchaRequired && (_jsx(Captcha, { value: captchaValue, onChange: setCaptchaValue, onCaptchaKeyChange: setCaptchaKey, reloadTrigger: captchaReload, onKeyDown: (e) => handleonKeyDown(e, "INPUT_PASSWORD"), isError: errorList.filter((err) => err.field === "cntError").length > 0, placeholder: t("라벨.보안문자") }))] })), _jsxs("ul", Object.assign({ className: "form__etc" }, { children: [_jsxs("li", { children: [_jsx("input", { type: "checkbox", id: "idsave", name: "chksave", checked: keepLoginYn == "Y" ? true : false, readOnly: true }), _jsx("label", Object.assign({ htmlFor: "idsave", className: "hide" }, { children: "\uB85C\uADF8\uC778 \uC720\uC9C0" }))] }), _jsxs("li", { children: [_jsx("button", Object.assign({ type: "button", className: "btn btn-txt js-open", "data-pop": "findId", onClick: (e) => CUTIL.jsopen_Popup(e) }, { children: _jsx("span", { children: t("라벨.아이디찾기") }) })), _jsx("button", Object.assign({ type: "button", className: "btn btn-txt js-open", "data-pop": "findPw", onClick: (e) => CUTIL.jsopen_Popup(e) }, { children: _jsx("span", { children: t("라벨.비밀번호찾기") }) }))] })] })), _jsx("button", Object.assign({ type: "button", className: "btn-login", onClick: (e) => onClickLogin(e) }, { children: _jsx("span", { children: t("라벨.로그인") }) }))] }) })) })), _jsxs("ul", Object.assign({ className: "join" }, { children: [_jsxs("li", { children: [_jsx("p", { children: t("라벨.아직회원이아닌가요") }), _jsx("button", Object.assign({ type: "button", className: "btn btn-txt js-open", "data-pop": "join", onClick: (e) => CUTIL.jsopen_Popup(e) }, { children: _jsx("span", { children: t("라벨.회원가입") }) }))] }), _jsx("li", { className: "join__sns" })] })), _jsx("div", { className: "select-lang" })] }))] })), _jsx(JoinPop, { onClickTermsPop: onClickTermsPop, onClickPrivacyPolicyPop: onClickPrivacyPolicyPop, onClickAgreementPop: onClickAgreementPop }), _jsx(JoinDonePop, {}), _jsx(JoinCompanyPop, {}), _jsx(JoinNewCompanyPop, {}), _jsx(FindIdPop, {}), _jsx(FindPwdPop, {}), _jsx(AlertPop, {}), _jsx(CommonPopup, {}), _jsx("div", { className: "dimm" }), " "] }));
}
export default Login;
